<template>
    <div>
        <div v-if="success" style="min-height:500px">
            <div v-if="finalQuestionnaire">
                <h1>Vielen Dank für deine abschließende Meinung</h1>
	            <div style="margin-top:15px;font-family:Roboto;">Wir freuen uns über deinen Beitrag zu unserer Aktion!
				<br/><br/>
				Sobald das Ergebnis der Umfrage feststeht, bekommst du eine Info von uns.<br/>
				Wir würden uns freuen, wenn wir dich bei einer künftigen Aktion bald wiedersehen. Schau doch am Besten gleich nach – vielleicht interessiert dich ja schon wieder etwas! <a href="/allProjects.html">Alle Aktionen</a>
				<br/><br/>
				Viele Grüße<br/>
				dein brands you love-Team</div>
            </div>
            <div v-else>
                <h2>Vielen Dank für deine Teilnahme</h2>
                <div>Damit hilfst du uns, brands you love noch besser zu machen.<br/><br/>
Viele Grüße<br/>
dein brands you love-Team</div>
            </div>
        </div>
	    <div v-if="!success">
	        <question-list :questions="survey.questionnaire.questionList" v-if="elementsLoaded" ref="questionList"></question-list>
	        <div id="errorbox" class="errorBox" v-if="hasError && !hasErrorMessage"><strong>Bitte korrigiere die markierten Fragen</strong></div>
	        <div id="errorbox" class="errorBox" v-if="hasError && hasErrorMessage"><strong>{{errorMessage}}</strong></div>
	        <button class="btn btn-white teaserButton width100" style="margin-top: 20px;" v-on:click="saveSurvey">SPEICHERN</button>
	    </div>
    </div>
</template>

<script>
    import QuestionList from './QuestionList.vue'

	export default {
		name: 'survey',
		props: {
			survey: Object
        },
        data: function() {
        	return {
        		elementsLoaded: false,
        		success : false,
        		finalQuestionnaire: false,
        		hasError: false,
        		hasErrorMessage: false,
        		errorMessage: ""
        	}
        },
        methods: {
        	validate() {
                return this.$refs.questionList.onValidate();
            },
        	saveSurveySuccess(data) {
            	if(data.success) {
            		this.success = true;
            	}else {
            		this.hasError = true;
            		this.hasErrorMessage = true;
            		this.errorMessage = data.whathappend;
            	}
            	if(data.finalQuestionnaire) {
            		this.finalQuestionnaire = true;
            	}
        	},
        	saveSurvey() {
        		//validate
                this.hasErrorMessage = false;
                let hasErrors = false;
                hasErrors = this.validate();
                
                this.hasError = hasErrors;
                
                if (hasErrors) {
                    console.log('There are errors');
                    jQuery("#errorbox").show();
                    return;
                }
                
            	var answers = [];
            	this.survey.questionnaire.questionList.forEach(function(item) {
            		if(item.propertyInfo.type.kind == 'MATRIX') {
            			var values = [];
            			for(var key in item.answer.value) {
            			    var value = item.answer.value[key];
            			    if(value) {
            			    	values.push(value);
            			    }
            			}
            			var answer = {};
            			answer.questionId = item.answer.questionId;
            			answer.type = item.answer.type;
            			answer.value = values;
            			answer.visible = item.answer.visible;
            			answers.push(answer);
            		}else {
            			answers.push(item.answer);
            		}
            	});
            	var survey = {};
            	survey.answers = answers;
            	survey.projectId = this.survey.projectId;
            	survey.surveyName = this.survey.shortName;
            	jQuery.ajax ({
                    url: '/saveSurvey',
                    type: 'POST',
                    dataType: "json",
                    data: JSON.stringify(survey),
                    contentType: "application/json; charset=utf-8",
                    success: this.saveSurveySuccess,
                    error: function() {console.log("could not save survey");}
                });
            },
            onElementsLoaded: function() {
                this.$nextTick(function() {
                    this.elementsLoaded = true;
                });
            }
        },
        components: { QuestionList }
	}
</script>


// WEBPACK FOOTER //
// Survey.vue?247b16d9